import {
  ACTIVITIES_COMPONENT_TYPE_IMAGE,
  ACTIVITIES_COMPONENT_TYPE_IMAGE_SPHERE,
  ACTIVITIES_COMPONENT_TYPE_INFO_BOX,
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_TABLE,
  ACTIVITIES_COMPONENT_TYPE_VIDEO,
  ACTIVITIES_COMPONENT_TYPE_EBOOK,
  ACTIVITIES_COMPONENT_TYPE_DOCUMENT,
  ACTIVITIES_COMPONENT_TYPE_AUDIO,
  ACTIVITIES_COMPONENT_TYPE_EBOOK_INTERACTIVE,
  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE,
  ACTIVITIES_COMPONENT_TYPE_LINK,
  ACTIVITIES_COMPONENT_TYPE_WEBTOOL,
  ACTIVITIES_COMPONENT_TYPE_GUIDED_RESEARCH,
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_MULTIPLE_CHOICE,
  ACTIVITIES_COMPONENT_TYPE_SLIDESHOW,
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_EQUATION_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_VOCABULARY,
  ACTIVITIES_COMPONENT_TYPE_DRAW,
  ACTIVITIES_COMPONENT_TYPE_DISCUSSION_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE_CATEGORISE,
  ACTIVITIES_COMPONENT_TYPE_RIVE_ANIMATION,
  ACTIVITIES_COMPONENT_TYPE_GIF,
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_FILL_IN_BLANKS_RESPONSE,
} from 'global/constants';
import {
  ComponentAudio,
  ComponentDocument,
  ComponentDraw,
  ComponentEbook,
  ComponentEbookInteractive,
  ComponentGuidedResearch,
  ComponentImage,
  ComponentInfoBox,
  ComponentInteractive,
  ComponentLink,
  ComponentMultipleChoice,
  ComponentEquationResponse,
  ComponentResponse,
  ComponentSlideshow,
  ComponentTable,
  ComponentVideo,
  ComponentVocabulary,
  ComponentDiscussion,
  ComponentInteractiveResponseSequence,
  ComponentInteractiveResponseCategorise,
  ComponentRiveAnimation,
  ComponentGif,
  ComponentFillInBlanks,
  ComponentImageSphere,
} from './component.constants';
import InfoBoxPrint from './info-box/info-box-print';
import ResponsePrint from './response/response-print';
import MultipleChoicePrint from './multiple-choice/multiple-choice-print';
import TablePrint from './table/table-print';
import SlideshowStaticPreview from './slideshow/slideshow-static-preview';
import DiscussionPrint from './discussion/discussion-print';
import DocumentStaticPreview from './document/document-static-preview';
import DrawStaticPreview from './draw/draw-static-preview';
import ImageStaticPreview from './image/image-static-preview';
import ImageSphereStaticPreview from './image-sphere/image-sphere-static-preview';
import InteractiveStaticPreview from './interactive/interactive-static-preview';
import LinkStaticPreview from './link/link-static-preview';
import VideoStaticPreview from './video/video-static-preview';
import GuidedResearchStaticPreview from './guided-research/guided-research-static-preview';
import EquationResponsePrint from './equation-response/equation-response-print';
import VocabularyPrint from './vocabulary/vocabulary-print';
import InteractiveResponseSequencePreview from './interactive-response/sequence/interactive-response-sequence-preview';
import InteractiveResponseCategorisePreview from './interactive-response/categorise/interactive-response-categorise-preview';
import type { InteractiveLessonSectionComponentFragment } from '../lesson-builder.graphql.generated';
import RiveStaticPreview from './rive/rive-static-preview';
import GifStaticPreview from './gif/gif-static-preview';
import FillInBlanksPreview from './fill-in-blanks/fill-in-blanks-preview';

type Props = {
  component: InteractiveLessonSectionComponentFragment;
};

const ComponentPreviewComponents = ({ component }: Props) => {
  return (
    <>
      {component.type === ACTIVITIES_COMPONENT_TYPE_INFO_BOX && (
        <InfoBoxPrint {...(component as ComponentInfoBox)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_SLIDESHOW && (
        <SlideshowStaticPreview {...(component as ComponentSlideshow)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_RESPONSE && (
        <ResponsePrint {...(component as ComponentResponse)} />
      )}

      {component.type ===
        ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_EQUATION_RESPONSE && (
        <EquationResponsePrint {...(component as ComponentEquationResponse)} />
      )}

      {component.type ===
        ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_MULTIPLE_CHOICE && (
        <MultipleChoicePrint
          {...(component as ComponentMultipleChoice)}
          previewSize={100}
        />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_TABLE && (
        <TablePrint {...(component as ComponentTable)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_EBOOK && (
        <DocumentStaticPreview {...(component as ComponentEbook)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_DOCUMENT && (
        <DocumentStaticPreview {...(component as ComponentDocument)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_VIDEO && (
        <VideoStaticPreview {...(component as ComponentVideo)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_AUDIO && (
        <VideoStaticPreview {...(component as ComponentAudio)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_IMAGE && (
        <ImageStaticPreview {...(component as ComponentImage)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_IMAGE_SPHERE && (
        <ImageSphereStaticPreview {...(component as ComponentImageSphere)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_INTERACTIVE && (
        <InteractiveStaticPreview {...(component as ComponentInteractive)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_EBOOK_INTERACTIVE && (
        <InteractiveStaticPreview
          {...(component as ComponentEbookInteractive)}
        />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_LINK && (
        <LinkStaticPreview {...(component as ComponentLink)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_WEBTOOL && (
        <LinkStaticPreview {...(component as ComponentLink)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_GUIDED_RESEARCH && (
        <GuidedResearchStaticPreview
          {...(component as ComponentGuidedResearch)}
        />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_VOCABULARY && (
        <VocabularyPrint {...(component as ComponentVocabulary)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_DRAW && (
        <DrawStaticPreview {...(component as ComponentDraw)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_DISCUSSION_RESPONSE && (
        <DiscussionPrint {...(component as ComponentDiscussion)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE && (
        <InteractiveResponseSequencePreview
          {...(component as ComponentInteractiveResponseSequence)}
        />
      )}

      {component.type ===
        ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE_CATEGORISE && (
        <InteractiveResponseCategorisePreview
          {...(component as ComponentInteractiveResponseCategorise)}
        />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_RIVE_ANIMATION && (
        <RiveStaticPreview {...(component as ComponentRiveAnimation)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_GIF && (
        <GifStaticPreview {...(component as ComponentGif)} />
      )}

      {component.type ===
        ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_FILL_IN_BLANKS_RESPONSE && (
        <FillInBlanksPreview {...(component as ComponentFillInBlanks)} />
      )}
    </>
  );
};

export default ComponentPreviewComponents;
